import { spaceClient } from './client';

export const createBooth = (boothData) =>
  spaceClient.post('/booth', boothData);

export const getBooths = () =>
  spaceClient.get('/cms/booths').then((r) => r.data);

export const getBoothById = (boothId) =>
  spaceClient.get(`/cms/booth/${boothId}`).then((r) => r.data);

export const updateBooth = (boothId, payload) =>
  spaceClient.put(`/booth/${boothId}`, payload, {
    headers: { 'Content-Type': 'application/json' },
  }).then((r) => r.data);

export const deleteBooth = (boothId) =>
  spaceClient.delete(`/booth/${boothId}`);

export const createMediaForBooth = (boothId, payload) =>
  spaceClient.post(`/booth/${boothId}/media`, payload);

export const updateBoothMedia = (boothId, mediaId, payload) =>
  spaceClient.put(`/booth/${boothId}/media/${mediaId}`, payload, {
    headers: { 'Content-Type': 'application/json' },
  }).then((r) => r.data);

export const deleteBoothMedia = (boothId, mediaId) =>
  spaceClient.delete(`/booth/${boothId}/media/${mediaId}`);

export const convertMediaToPortal = (boothId, mediaId, dto) =>
  spaceClient.post(`/booth/${boothId}/media/${mediaId}/convert-to-portal`, dto).then((r) => r.data);

export const convertMediaToCustom = (boothId, mediaId, dto) =>
  spaceClient.post(`/booth/${boothId}/media/${mediaId}/convert-to-custom`, dto).then((r) => r.data);
